import { render, staticRenderFns } from "./doctorInformation.vue?vue&type=template&id=f18b6de6&scoped=true"
import script from "./doctorInformation.vue?vue&type=script&lang=js"
export * from "./doctorInformation.vue?vue&type=script&lang=js"
import style0 from "./doctorInformation.vue?vue&type=style&index=0&id=f18b6de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18b6de6",
  null
  
)

export default component.exports